import { REFERRER } from "../const/cookies.mjs";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { navigateTo, useCookie } from "#app";
const exclude = [/auth/, /login/, /register/];
export function useAppRouter() {
  const { push } = useRouter();
  const { query, fullPath } = useRoute();
  const { locale } = useI18n();
  const referrer = useCookie(REFERRER);
  const { afterEach } = useRouter();
  async function redirect(path, opts = {}) {
    const localizedPath = prefixPath(path, locale.value);
    try {
      await navigateTo({ path: localizedPath, ...opts });
      if (opts?.onComplete)
        opts?.onComplete();
    } catch (err) {
      if (err.name !== "NavigationDuplicated") {
        throw err;
      }
    }
  }
  afterEach((_, from) => {
    !exclude.some((r) => r.test(from.path)) && !process.server && (() => {
      localStorage.setItem("LS_ROUTE_KEY", from.path);
      referrer.value = from.path;
      referrer.value = from.path;
    })();
  });
  function back() {
    const lastRouteName = localStorage.getItem("LS_ROUTE_KEY");
    if (lastRouteName) {
      return push(lastRouteName);
    }
    return push(prefixPath("/", locale.value));
  }
  const lastRoute = process.client ? localStorage.getItem("LS_ROUTE_KEY") : "";
  return {
    redirect,
    query,
    back,
    lastRoute,
    fullPath
  };
}
function prefixPath(path, locale) {
  if (!path.startsWith(`/${locale}/`)) {
    return `/${locale}${path}`;
  }
  return path;
}
